import { render, staticRenderFns } from "./TableFormatQuestion.vue?vue&type=template&id=1bb751fd&scoped=true&"
import script from "./TableFormatQuestion.vue?vue&type=script&lang=ts&"
export * from "./TableFormatQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb751fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardActions,VIcon})
